/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-data-chart-bar': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M16.875 17.5V3.75h-5V17.5h-2.5V8.75h-5v8.75H2.5V1.25H1.25V17.5c0 .69.56 1.25 1.25 1.25h16.25V17.5h-1.875zm-8.75 0h-2.5V10h2.5v7.5zm7.5 0h-2.5V5h2.5v12.5z"/>'
  }
})
